import { render, staticRenderFns } from "./CampusConfig.vue?vue&type=template&id=64976faa&scoped=true"
import script from "./CampusConfig.vue?vue&type=script&lang=js"
export * from "./CampusConfig.vue?vue&type=script&lang=js"
import style0 from "./CampusConfig.vue?vue&type=style&index=0&id=64976faa&prod&scoped=true&lang=css"
import style1 from "./CampusConfig.vue?vue&type=style&index=1&id=64976faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64976faa",
  null
  
)

export default component.exports